<template>
  <v-app>
    <v-main style="padding-bottom: 100px;">
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    
  }),
};
</script>
